var map = {
	"./BusinessintheTimeofContagion.jpeg": 586,
	"./LakshmiSubramanian.png": 587,
	"./LouizaRodrigues.png": 588,
	"./MadMenofBombay.png": 589,
	"./PowerPrivilegePosture.jpeg": 590,
	"./SaritaSundar.png": 591,
	"./Speaker1.png": 592,
	"./TheGlobalBlueJeansTransformation.jpg": 593,
	"./TimberTradeTrajectory.jpeg": 594,
	"./TraceyPanek.png": 595,
	"./TypewriterTipTip.png": 596,
	"./WilliamMazzarella.png": 597,
	"./details-banner/BusinessInTheTimeOfContagion.png": 598,
	"./details-banner/MadMenOfBombay.png": 599,
	"./details-banner/PowerPrivilegeposture.png": 600,
	"./details-banner/TheGlobalBlueJeans.png": 601,
	"./details-banner/TimberTradeTrajectory.png": 602,
	"./details-banner/TypewriterTipTip.png": 603
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 585;